// tslint:disable
import { Power1, Power4, TimelineLite, TweenLite } from "gsap";
import "pixi-particles";
import "pixi-spine";
import "pixi.js";
// tslint:enable
import { BehaviorSubject } from "rxjs";
import { delay, filter, take } from "rxjs/operators";
import { IdPersistence } from "../../constants/IdPersistence";
import { PersistenceMode } from "../PersistenceMode";
import { utilFps } from "../utilFps";
import { utilPersistence } from "../utilPersistence";
var Spine = PIXI.spine.Spine;
var UtilAnimation = /** @class */ (function () {
    function UtilAnimation() {
        var _this = this;
        this.animationDescriptorsById = new Map();
        this.registerAnimations = function (resources) {
            Object.keys(resources).reduce(function (acc, key) {
                var resource = resources[key];
                if (resource.spineData == undefined) {
                    return acc;
                }
                acc.set(key, resource.spineData);
                return acc;
            }, _this.animationDescriptorsById);
            _this.loadedAnimationId$.next(_this.animationDescriptorsById);
        };
        this.getSpineAnimation = function (id) {
            var data = _this.animationDescriptorsById.get(id);
            if (data == undefined) {
                return undefined;
            }
            return new Spine(data);
        };
        this.startParticleAnimation = function (emitter, playOnce, forceAnimation, animDelay) {
            if (playOnce === void 0) { playOnce = false; }
            if (forceAnimation === void 0) { forceAnimation = false; }
            if (animDelay === void 0) { animDelay = 0; }
            var requestAnimationFrameId = playOnce ? -1 : 1;
            if (_this.isAnimationEnabled() || forceAnimation) {
                // Calculate the current time
                var elapsed_1 = Date.now() + animDelay * 1000;
                if (requestAnimationFrameId === -1) {
                    // emitter.playOnceAndDestroy has the side-effect of setting autoUpdate to true
                    emitter.playOnceAndDestroy(function () {
                        emitter.emit = false;
                        emitter.destroy();
                    });
                    // so we need to manually set it off.
                    emitter.autoUpdate = false;
                }
                // Update function every frame
                var update_1 = function () {
                    // Update the next frame
                    requestAnimationFrameId = requestAnimationFrame(update_1);
                    var now = Date.now();
                    // The emitter requires the elapsed
                    // number of seconds since the last update
                    var delta = (now - elapsed_1) * 0.001;
                    emitter.update(delta);
                    elapsed_1 = now;
                };
                // Start the update
                if (animDelay > 0) {
                    setTimeout(function () {
                        emitter.emit = true;
                        update_1();
                    }, animDelay * 1000);
                }
                else {
                    emitter.emit = true;
                    update_1();
                }
            }
            return requestAnimationFrameId;
        };
        this.destroyParticleAnimation = function (emitter, requestAnimationFrameId) {
            if (requestAnimationFrameId === void 0) { requestAnimationFrameId = -1; }
            cancelAnimationFrame(requestAnimationFrameId);
            emitter.emit = false;
            emitter.destroy();
        };
        this.getAnimLoaded$ = function (animId) {
            return _this.loadedAnimationId$.pipe(filter(function (map) { return map.has(animId); }), take(1), delay(1));
        };
        this.startRewardPelletAnimation = function (animationInfo, onCompleteCallback) {
            var InitialScale = 0.5;
            var FinalScale = 1;
            var BezierDuration = 1.5;
            var UpriseDuration = 1;
            var DropSpotDelay = 0.25;
            var InitialOpacity = 1;
            var FinalOpacity = 0;
            var elementId = animationInfo.elementId, bezierPoint = animationInfo.bezierPoint, endPoint = animationInfo.endPoint;
            var animation = new TimelineLite({ pause: true });
            var BezierCurveDropProps = {
                type: "soft",
                values: [
                    { x: 0, y: 0 },
                    {
                        x: bezierPoint.x,
                        y: bezierPoint.y - 100,
                    },
                    {
                        x: endPoint.x,
                        y: endPoint.y,
                    },
                ],
            };
            var BezierCurveUpriseProps = {
                type: "soft",
                values: [
                    {
                        x: endPoint.x,
                        y: endPoint.y,
                    },
                    {
                        x: endPoint.x,
                        y: bezierPoint.y - 100,
                    },
                ],
            };
            animation
                .fromTo(elementId, BezierDuration, { scale: InitialScale, force3D: false }, {
                bezier: BezierCurveDropProps,
                ease: Power4.easeOut,
                scale: FinalScale,
            })
                .fromTo(elementId, UpriseDuration, { autoAlpha: InitialOpacity, force3D: false }, {
                autoAlpha: FinalOpacity,
                bezier: BezierCurveUpriseProps,
                delay: DropSpotDelay,
                ease: Power1.easeIn,
                onComplete: function () {
                    onCompleteCallback(elementId);
                },
            })
                .play();
            return animation;
        };
        this.createFireworkExplosion = function (item, onCompleteCallback) {
            var tweenAnim = new TimelineLite({ pause: true });
            var element = document.getElementById(item.elementId);
            if (element) {
                var particleMinSize = 2;
                var particleMaxSize = 6;
                var speed = 0.5;
                var gravity = 0.2;
                var getRandom_1 = function (min, max) { return min + Math.random() * (max - min); };
                // color range yellow - white
                var getRandomColor = function () {
                    var h = getRandom_1(20, 90);
                    var s = getRandom_1(90, 100);
                    var l = getRandom_1(60, 100);
                    var a = 1;
                    return "hsl(" + h + ", " + s + "%, " + l + "%, " + a + ")";
                };
                var size = getRandom_1(particleMinSize, particleMaxSize);
                var angle = Math.random() * Math.PI * 2;
                var length = (Math.random() * size) / 2;
                var dotColor = getRandomColor();
                TweenLite.set(element, {
                    backgroundColor: "" + dotColor,
                    boxShadow: "0 0 20px 1px " + dotColor,
                    force3D: true,
                    height: size,
                    visibility: "hidden",
                    width: size,
                    x: Math.cos(angle) * length,
                    xPercent: -50,
                    y: Math.sin(angle) * length,
                    yPercent: -50,
                });
                tweenAnim.to(element, item.time, {
                    autoAlpha: 0,
                    onComplete: function () {
                        onCompleteCallback(item.elementId);
                    },
                    physics2D: {
                        angle: (angle * 180) / Math.PI,
                        gravity: 700 * gravity,
                        velocity: (100 + Math.random() * 300) * speed,
                    },
                    visibility: "visible",
                }, 0);
            }
            return tweenAnim;
        };
        this.shouldPlayAnimation = function () {
            return utilFps.getAnimationAvgFps() > 12;
        };
        this.setAnimationSettings = function (animationEnabled, autoAnimation, fpsLimit) {
            if (fpsLimit === void 0) { fpsLimit = 60; }
            utilPersistence.setValue(IdPersistence.AnimationSettings, {
                animationEnabled: animationEnabled,
                autoAnimation: autoAnimation,
                fpsLimit: fpsLimit,
            }, PersistenceMode.Write);
        };
        this.isAnimationEnabled = function () { return _this.getAnimationSetting().animationEnabled; };
        this.getAnimationSetting = function () {
            return utilPersistence.getValue(IdPersistence.AnimationSettings, {
                animationEnabled: false,
                autoAnimation: true,
                fpsLimit: 60,
            });
        };
        this.animateCrossfade = function (duration, from, to, onComplete) {
            TweenLite.to(from, duration, {
                alpha: 0,
            });
            TweenLite.to(to, duration, {
                alpha: 1,
                onComplete: onComplete,
            });
        };
        this.loadedAnimationId$ = new BehaviorSubject(this.animationDescriptorsById);
    }
    return UtilAnimation;
}());
export var utilAnimation = new UtilAnimation();



//////////////////
// WEBPACK FOOTER
// ./src/utils/animation/utilAnimation.ts
// module id = 106
// module chunks = 3